import { $t } from "@/plugins/i18n";
import { tableView } from "@/router/enums";

const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/wb-manage-teacher",
    component: Layout,
    redirect: "/wb-manage/wb-manage-teacher",
    meta: {
      icon: "ic/outline-supervised-user-circle",
      title: $t("wb.menu.teacherManage"),
      rank: tableView + 1
    },
    children: [
      {
        path: "/wb-manage/wb-manage-teacher",
        name: "WbManageTeacher",
        component: () =>
          import("@/views/wb-manage/wb-manage-teacher/index.vue"),
        meta: {
          title: $t("wb.menu.teacherManage"),
          icon: "ic/outline-supervised-user-circle",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-manage-student",
    component: Layout,
    redirect: "/wb-manage/wb-manage-student",
    meta: {
      icon: "ic/outline-people",
      title: $t("wb.menu.studentManage"),
      rank: tableView + 2
    },
    children: [
      {
        path: "/wb-manage/wb-manage-student",
        name: "WbManageStudent",
        component: () =>
          import("@/views/wb-manage/wb-manage-student/index.vue"),
        meta: {
          title: $t("wb.menu.studentManage"),
          icon: "ic/outline-people",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-lesson-list",
    component: Layout,
    redirect: "/wb-manage/wb-lesson-list",
    meta: {
      icon: "ic/outline-menu-book",
      title: $t("wb.menu.lessonListTitle"),
      rank: tableView + 3
    },
    children: [
      {
        path: "/wb-manage/wb-lesson-list",
        name: "WbManageLessonList",
        component: () => import("@/views/wb-manage/wb-lesson-list/index.vue"),
        meta: {
          title: $t("wb.menu.lessonListTitle"),
          icon: "ic/outline-menu-book",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-manage-credit-log",
    component: Layout,
    redirect: "/wb-manage/wb-manage-credit-log",
    meta: {
      icon: "ic/outline-account-balance-wallet",
      title: $t("wb.menu.creditLog"),
      rank: tableView + 4
    },
    children: [
      {
        path: "/wb-manage/wb-manage-credit-log",
        name: "WbManageCreditLog",
        component: () =>
          import("@/views/wb-manage/wb-manage-credit-log/index.vue"),
        meta: {
          title: $t("wb.menu.creditLog"),
          icon: "ic/outline-account-balance-wallet",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-manage-credit-shortfall",
    component: Layout,
    redirect: "/wb-manage/wb-manage-credit-shortfall",
    meta: {
      icon: "ic/baseline-credit-card-off",
      title: $t("wb.menu.creditShortfall"),
      rank: tableView + 5
    },
    children: [
      {
        path: "/wb-manage/wb-manage-credit-shortfall",
        name: "WbManageCreditShortfall",
        component: () => import("@/views/wb-manage/credit-shortfall/index.vue"),
        meta: {
          title: $t("wb.menu.creditShortfall"),
          icon: "ic/baseline-credit-card-off",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-manage-bills",
    component: Layout,
    redirect: "/wb-manage/wb-manage-bills",
    meta: {
      icon: "ic/outline-receipt",
      title: $t("wb.menu.bills"),
      rank: tableView + 6
    },
    children: [
      {
        path: "/wb-manage/wb-manage-bills",
        name: "WbManageBills",
        component: () => import("@/views/wb-manage/wb-manage-bills/index.vue"),
        meta: {
          title: $t("wb.menu.bills"),
          icon: "ic/outline-receipt",
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  },
  {
    path: "/wb-manage-hidden",
    component: Layout,
    meta: {
      title: $t("menus.pureEmpty"),
      showLink: false
    },
    children: [
      {
        path: "/wb-manage/wb-manage-update-classroom/:classroom_id(.*)",
        name: "WbManageClassroom",
        component: () =>
          import("@/views/wb-manage/wb-manage-update-classroom/index.vue"),
        meta: {
          title: $t("wb.menu.classroomDetail"),
          showLink: false,
          keepAlive: true,
          roles: ["manager"]
        }
      },
      {
        path: "/wb-manage/wb-manage-create-classroom",
        name: "WbManageCreateClassroom",
        component: () =>
          import("@/views/wb-manage/wb-manage-create-classroom/index.vue"),
        meta: {
          title: $t("wb.menu.classroomDetail"),
          showLink: false,
          keepAlive: true,
          roles: ["manager"]
        }
      },
      {
        path: "/wb-manage/wb-manage-create-classroom/:student(.*)",
        name: "WbManageCreateClassroomParam",
        component: () =>
          import("@/views/wb-manage/wb-manage-create-classroom/index.vue"),
        meta: {
          title: $t("wb.menu.classroomDetail"),
          showLink: false,
          keepAlive: true,
          roles: ["manager"]
        }
      },
      {
        path: "/wb-manage/wb-manage-classroom-detail",
        name: "WbManageClassroomDetail",
        component: () =>
          import("@/views/wb-manage/wb-manage-classroom-detail/index.vue"),
        meta: {
          title: $t("wb.menu.classroomDetail"),
          showLink: false,
          keepAlive: true,
          roles: ["manager"]
        }
      },
      {
        path: "/wb-manage/wb-manage-bill-detail",
        name: "WbManageBillDetail",
        component: () => import("@/views/wb-manage/wb-manage-bills/detail.vue"),
        meta: {
          title: $t("wb.menu.billDetail"),
          showLink: false,
          keepAlive: true,
          roles: ["manager"]
        }
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
